/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlUploadFile = "/asset/upload-files";
const state = {};

const actions = {
  async uploadFile({ commit }, payload) {
    try {
      const response = await axios.post(urlUploadFile, payload);
      if (response.data.status_code === 200) {
        return response.data.data;
      }
      return [];
    } catch (e) {
      console.log("exception: ", e);
      return [];
    }
  },

  async changeFileName({ commit }, payload) {
    const response = await axios.put("/asset/change-file-name", payload);
    return response.data;
  },
};

const mutations = {};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
